import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Sopimuspohja',
  tabs: {
    [info_tab]: 'Tiedot',
    [preview_tab]: 'Esikatselu',
  },
  sections: {
    subscription: 'Tilaus',
    setup_cost: 'Käyttöönottokustannus',
    preview: 'Esikatselu',
  },
  form: {
    has_trial: {
      label: 'Lisää kokeilupäiviä',
    },
    trial_days: {
      label: 'Ilmaiset kokeilupäivät',
      placeholder: '7',
      validation: {
        required: 'Kokeilupäivät vaaditaan',
        min: '{{value}} on kokeilupäivien vähimmäisarvo',
      },
    },
  },
  buttons: {
    apply: 'Ota muutokset käyttöön',
    download: 'Lataa',
    apply_changes: 'Ota muutokset käyttöön',
  },
  files: {
    contract: '{{provider}}-sopimuspohja-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Esikatselun lataaminen epäonnistui',
  },
};
